import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
  selector: 'home-trader-courses',
  templateUrl: './home-trader-courses.component.html',
  styleUrls: ['./home-trader-courses.component.scss']
})
export class HomeTraderCoursesComponent {

  public availableCourses: any[] = [
    {
      id: "room",
      iconPath: "home/assets/svg-icons/play-icon.svg",
      title: "Salas de trading",
      text: "Acompanhe experts do mercado operando e dando dicas ao vivo.",
      url: "/lp-profit-pro",
    },
  ];

  constructor(
    private store: Store<any>,
  ) { }

  public navigateTo(path: string, element: string) {
    this.sendTracking("Element Clicked", {
      'Product Area Origin': "Home Trader",
      'Time Responsável': "Brooklyn Dumbo",
      Element: element,
    });
    window.open(path, '_blank');
  }

  public sendTracking(event: string, breakdowns: any) {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: { type: event, events: breakdowns },
    });
  }
}
